// Central site configuration — real details from Dr. Sanjay Teza's master profile.
export const SITE = {
  doctorName: "Dr. Sanjay Teza",
  doctorTitle: "ENT Specialist & Surgeon",
  qualifications: "MBBS, MS (ENT) — Banaras Hindu University",
  clinicName: "Dr. Sanjay Teza ENT Center",
  tagline: "Ear, Nose & Throat care in Varanasi",
  experienceYears: 25,
  patientsTreated: "3 Lakh+",
  city: "Varanasi",

  // --- Contact ---
  phoneDisplay: "+91 93369 22349",
  phoneRaw: "+919336922349",
  whatsapp: "919336922349",
  email: "drsanjayteza@gmail.com",

  // Primary clinic (used in header/footer/schema)
  addressLine1: "20, Shakumbhari Complex, Peace Point Road, Anandbagh, Bhelupur",
  addressLine2: "Varanasi, Uttar Pradesh 221001",
  addressFull:
    "20, Shakumbhari Complex, Peace Point Road, Near Chetmani Chauraha, Anandbagh, Bhelupur, Varanasi, Uttar Pradesh 221001",
  geo: { lat: 25.3037, lng: 82.9942 },

  // --- Two clinic locations ---
  clinics: [
    {
      name: "Dr. Sanjay Teza ENT Center",
      area: "Bhelupur",
      addressFull:
        "20, Shakumbhari Complex, Peace Point Road, Near Chetmani Chauraha, Anandbagh, Bhelupur, Varanasi, Uttar Pradesh 221001",
      timings: "Mon – Sat: 5:00 PM – 7:00 PM",
      phone: "+91 93369 22349",
      gbpLink: "https://maps.app.goo.gl/d2S4HM2MApGLwgFL6",
      mapEmbed:
        "https://www.google.com/maps?q=Dr.+Sanjay+Teza+ENT+Center+Shakumbhari+Complex+Bhelupur+Varanasi+221001&output=embed",
      landmarks: ["Near Chetmani Chauraha, Anandbagh", "In Bhelupur, central Varanasi"],
      parking: "On-street and nearby parking available around Peace Point Road.",
    },
    {
      name: "Vardaan Hospital",
      area: "Sundarpur / Newada",
      addressFull:
        "BHU Road, Near Newada Petrol Pump, Sundarpur, Newada, Varanasi, Uttar Pradesh 221005",
      timings: "Mon – Sat: 10:00 AM – 2:00 PM",
      phone: "+91 93369 22349",
      gbpLink: "https://maps.app.goo.gl/jdge9ABNk2rFWpbL8",
      mapEmbed:
        "https://www.google.com/maps?q=Vardaan+Hospital+BHU+Road+Newada+Sundarpur+Varanasi+221005&output=embed",
      landmarks: ["Near Newada Petrol Pump, on BHU Road", "Close to Banaras Hindu University (BHU)"],
      parking: "Dedicated hospital parking available on-site.",
    },
  ],

  awards: ["Health Legends Award", "Dainik Jagran Wellness+ Healthcare Award"],
  memberships: [
    "Indian Medical Association (IMA)",
    "Association of Otolaryngologists of India (AOI)",
  ],

  // Consolidated hours (both clinics)
  hours: [
    { day: "Bhelupur Center (Mon – Sat)", time: "5:00 PM – 7:00 PM" },
    { day: "Vardaan Hospital (Mon – Sat)", time: "10:00 AM – 2:00 PM" },
    { day: "Sunday", time: "Closed / Emergency only" },
  ],

  mapLink: "https://maps.app.goo.gl/d2S4HM2MApGLwgFL6",

  nav: [
    { label: "Home", to: "/" },
    { label: "ENT FAQs", to: "/ent-faqs-varanasi" },
    { label: "Treatment Guide", to: "/ent-treatment-guide-varanasi" },
    { label: "Contact", to: "/contact" },
  ],
};

export const waLink = (message) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(message || "")}`;
